import { render } from "./OrderDetails.vue?vue&type=template&id=bbb61144"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=bbb61144&lang=css"

import exportComponent from "E:\\Source\\平台项目\\YUNCar\\Source\\Delivery.Mobile.UI\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__